import { FC } from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { splitLongNames } from 'string-utils';

const FixFiles: FC<React.PropsWithChildren<FixFilesProps>> = ({ files }) => {
  return (
    <Box display='flex' flexDirection='column'>
      <Typography sx={{ mb: 2 }} variant='body2' color='text.secondary'>
        Files being modified
      </Typography>

      {files.map(file => (
        <Tooltip
          key={file}
          title={
            <Typography variant='body2' color='text.primary'>
              {file}
            </Typography>
          }>
          <Typography variant='body2' color='text.primary'>
            {splitLongNames(file, 30)}
          </Typography>
        </Tooltip>
      ))}
    </Box>
  );
};

export interface FixFilesProps {
  files: string[];
}

export default FixFiles;
